import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import DateChooser from './date-chooser';

export const load = (lang, nodeId) => {
    ReactDOM.render(
		<React.StrictMode>
			<React.Fragment>
                <Form  lang={lang} />
			</React.Fragment>
		</React.StrictMode>,
		document.getElementById(nodeId)
    )
}

function Form (props) {
    const [lang, setLang] = useState(null);
    const [date, setDate] = useState(new Date().toISOString().substring(0, 10));
    const [data, setData] = useState(null);
    const [selectedOverseer, setSelectedOverseer] = useState(null);

    useEffect(() => {
        fetch("/js/" + props.lang + "/translation.js")
        .then(res => res.json())
        .then(res => {
            setLang(res);
        });
    }, [props.lang]);

    useEffect(() => {
        if (date?.length == 10) {
            setData(null)

            fetch("/" + props.lang + "/surveillance/reports/study-rooms/fetch/" + date)
            .then(res => res.json())
            .then(res => {
                setData(res);

                if (selectedOverseer != null) {
                    let overseer = res.overseers.find(item => item.id == selectedOverseer.id);
                    if (overseer != null) {
                        setSelectedOverseer(overseer);
                    } else {
                        setSelectedOverseer(null);
                    }
                }
            });
        }
    }, [date]);

    return <div className='container'>
                {
                    lang != null && data != null ?
                        <>
                            <div className='d-flex justify-content-between align-items-center'>
                                <DateChooser className=" justify-content-start" offsetCount={7} date={date} onChange={(val) => setDate(val)} />
                                <div className='fs-5'>
                                    {lang.gen["Week of"]} : {data.first_day_of_week}
                                </div>
                            </div>
                            <div>
                                {
                                    selectedOverseer == null ?
                                        <table className='table table-bordered table-striped table-hover mt-3'>
                                            <thead>
                                                <tr>
                                                    <th>{lang.gen["overseer"]}</th>
                                                    <th className='text-center'>{lang.gen["In study hall count"]}</th>
                                                    <th className='text-center'>{lang.gen["In study hall count with students"]}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.overseers.map((item, index) => {
                                                        return <tr key={index}>
                                                            <td>
                                                                <a className='text-decoration-none cursor-pointer' onClick={e => setSelectedOverseer(item)}>
                                                                    {item.last_name}, {item.first_name}
                                                                </a>
                                                            </td>
                                                            <td className={"text-center " + (item.in_study_halls > 0 ? "text-primary fw-bold" : "")}>{item.in_study_halls}</td>
                                                            <td className={"text-center " + (item.in_study_halls_with_students > 0 ? "text-primary fw-bold" : "")}>{item.in_study_halls_with_students}</td>
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    :
                                        <div className='mt-5'>
                                            <div className='d-flex gap-3'>
                                                <div>
                                                    <button className='btn btn-sm btn-secondary' onClick={e => setSelectedOverseer(null)}>{lang.gen["Back"]}</button>
                                                </div>
                                                <h4>
                                                {selectedOverseer.last_name}, {selectedOverseer.first_name}
                                                </h4>
                                            </div>
                                            <table className='table table-bordered table-striped table-hover mt-3'>
                                                <thead>
                                                    <tr>
                                                        <th>{lang.gen["Period"]}</th>
                                                        {
                                                            [lang.gen["Monday"], lang.gen["Tuesday"], lang.gen["Wednesday"], lang.gen["Thursday"], lang.gen["Friday"]].map((dayOfWeek, index) => {
                                                                return <th className='text-center' key={"d-" + index}>{dayOfWeek}</th>
                                                            })
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        [0, 1, 2, 3, 4, 5].map((period) => {
                                                            return  <tr key={"p-" + period}>
                                                                        <td className=''>{lang.gen["Period"]} {period + 1}</td>
                                                                        {
                                                                            [0, 1, 2, 3, 4].map((dayOfWeek) => {
                                                                                return  <td className='text-center' key={"dow-" + dayOfWeek}>
                                                                                            {
                                                                                                selectedOverseer.days[dayOfWeek][period] == -1 ?
                                                                                                    <span className='fs-5 fa fa-check text-muted opacity-25'></span>
                                                                                                :
                                                                                                selectedOverseer.days[dayOfWeek][period] > 0 ?
                                                                                                    <span title={"Absence #" + selectedOverseer.days[dayOfWeek][period]} className='fs-5 fa fa-check text-success'></span>
                                                                                                :
                                                                                                    <span className='opacity-25'>-</span>
                                                                                            }
                                                                                        </td>
                                                                            })
                                                                        }
                                                                    </tr>
                                                        })
                                                    }
                                                    <tr>
                                                        <td className=''>{lang.gen["Total"]}</td>
                                                        {
                                                            [0, 1, 2, 3, 4].map((dayOfWeek) => {
                                                                return  <td className='text-center' key={"dow-" + dayOfWeek}>
                                                                    <div className='d-flex justify-content-center align-items-center gap-3 '>
                                                                        <div className='d-flex justify-content-center align-items-center gap-1'>
                                                                            {selectedOverseer.days[dayOfWeek].reduce((a, b) => a + (b == -1 ? 1 : 0), 0)}
                                                                            <span className='fa fa-check text-muted opacity-25'></span>
                                                                        </div>
                                                                        <div className='d-flex justify-content-center align-items-center gap-1'>
                                                                            {selectedOverseer.days[dayOfWeek].reduce((a, b) => a + (b > 0 ? 1 : 0), 0)}
                                                                            <span className='fa fa-check text-success'></span>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            })
                                                        }
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className='mt-2'>
                                                <div className='d-flex justify-content-start align-items-center gap-2'>
                                                    <span className='fa fa-check text-muted opacity-25'></span>
                                                    <span className=''>{lang.gen["In study hall count"]}</span>
                                                </div>
                                                <div className='d-flex justify-content-start align-items-center gap-2'>
                                                    <span className='fa fa-check text-success'></span>
                                                    <span className=''>{lang.gen["In study hall count with students"]}</span>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </>
                    :
                        <div className='d-flex justify-content-center pt-5'>
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                }
          </div>
}